import { render } from "./AccountResetPassword.vue?vue&type=template&id=63a3d325&scoped=true"
import script from "./AccountResetPassword.vue?vue&type=script&lang=js"
export * from "./AccountResetPassword.vue?vue&type=script&lang=js"

import "./AccountResetPassword.vue?vue&type=style&index=0&id=63a3d325&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-63a3d325"

export default script